var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"IssuesBody"},_vm._l((_vm.loanIssues),function(item,index){return _c('div',{key:index},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(item.title))]),_c('div',{staticClass:"content"},[_vm._v(_vm._s(item.content))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }